import { Component, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'signet-logo',
  styleUrl: 'signet-logo.scss',
  shadow: false,
})
export class SignetLogo {
  /**
   * The name of the product. This is used to determine the logo to display.
   */
  @Prop() name:
    | 'episource'
    | 'coder'
    | 'analyst'
    | 'submitter'
    | 'hub'
    | 'signet'
    | 'connect'
    | 'adaptive-coder'
    | 'portal' = 'episource';

  /**
   * The alternative text for the logo image.
   * This is used for accessibility purposes.
   * It is set based on the product name.
   * If not provided, a default value will be used.
   * @default 'EpiSource Logo'
   */
  /**
   * The alternative text for the logo image.
   * This is used for accessibility purposes.
   * It is set based on the product name.
   * If not provided, a default value will be used.
   * @default 'EpiSource Logo'
   */
  @Prop() alt?: string;

  /**
   * The destination URL for the logo link.
   * This is set based on the product name.
   * If not provided, a default value will be used.
   * @default 'http://episource.com'
   */
  @Prop() href?: string;

  /**
   * Each logo already has a default src file.
   * If you want to change your logo, you can specify another image src. 
   * @default ''
   */
  @Prop() src?: string;

  private getLogoLink(): string {
    if (this.href) return this.href;
    if (this.name === 'coder') {
      return 'http://coder.episource.com';
    } else if (this.name === 'analyst') {
      return 'http://analyst.episource.com';
    } else if (this.name === 'episource') {
      return 'http://episource.com';
    } else if (this.name === 'submitter') {
      return 'http://submitter.episource.com';
    } else if (this.name === 'hub') {
      return 'http://hub.episource.com';
    } else if (this.name === 'signet') {
      return 'http://design.episource.com';
    } else if (this.name === 'connect') {
      return 'http://connect.episource.com';
    } else if (this.name === 'portal') {
      return 'http://episource.com';
    } else if (this.name === 'adaptive-coder') {
      return 'http://coder.episource.com';
    }
    return 'http://episource.com';
  }

  private getImageLink(): string {
    if (this.src) return this.src;
    if (this.name === 'coder') {
      return 'https://design.episource.com/img/logo/Product=Coder.svg';
    } else if (this.name === 'analyst') {
      return 'https://design.episource.com/img/logo/Product=Analyst.svg';
    } else if (this.name === 'episource') {
      return 'https://design.episource.com/img/logo/Product=Global.svg';
    } else if (this.name === 'submitter') {
      return 'https://design.episource.com/img/logo/Product=Submitter.svg';
    } else if (this.name === 'hub') {
      return 'https://design.episource.com/img/logo/Product=Hub.svg';
    } else if (this.name === 'signet') {
      return 'https://design.episource.com/img/logo/Product=Signet.svg';
    } else if (this.name === 'connect') {
      return 'https://design.episource.com/img/logo/Product=Epiconnect.svg';
    } else if (this.name === 'portal') {
      return 'https://design.episource.com/img/logo/Product=Portal.svg';
    } else if (this.name === 'adaptive-coder') {
      return 'https://design.episource.com/img/logo/Product=AC.svg';
    }
    return 'https://design.episource.com/img/logo/Product=Global.svg';
  }

  private getAltText(): string {
    if (this.alt) return this.alt;
    if (this.name === 'coder') {
      return 'EpiCoder Logo';
    } else if (this.name === 'analyst') {
      return 'EpiAnalyst Logo';
    } else if (this.name === 'episource') {
      return 'EpiSource Logo';
    } else if (this.name === 'submitter') {
      return 'EpiSubmitter Logo';
    } else if (this.name === 'hub') {
      return 'EpiHub Logo';
    } else if (this.name === 'signet') {
      return 'EpiSignet Logo';
    } else if (this.name === 'connect') {
      return 'EpiConnect Logo';
    } else if (this.name === 'portal') {
      return 'EpiPortal Logo';
    } else if (this.name === 'adaptive-coder') {
      return 'Adaptive Coder Logo';
    }
    return 'EpiSource Logo';
  }

  render() {
    return (
      <a class="signet-logo-link" href={this.getLogoLink()}>
        <slot name="logo">
          <img class="logo" src={this.getImageLink()} alt={this.getAltText()} />
        </slot>
      </a>
    );
  }
}
